package com.nonopn.skydome.common.app.pages.estimate

import androidx.compose.desktop.ui.tooling.preview.Preview
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.TextFieldValue
import com.nonopn.skydome.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.estimate_email
import com.nonopn.skywatcher.design.utils.localized
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.widgets.CustomOutlinedEditText
import eu.codlab.compose.widgets.TextNormal

@Composable
fun EstimateConfigurationEmail(
    modifier: Modifier,
    model: EstimateScreenModel
) {
    var email by remember {
        mutableStateOf(
            TextFieldValue(
                model.states.value.estimateEmail
            )
        )
    }

    CustomOutlinedEditText(
        modifier = modifier,
        value = email,
        onValueChanged = {
            email = it
            model.setEmail(it.text)
        },
        label = {
            TextNormal(
                text = Res.string.estimate_email.localized()
            )
        }
    )
}

@Preview
@HotPreview(widthDp = 1200, heightDp = 800, darkMode = true)
@HotPreview(widthDp = 1200, heightDp = 800, darkMode = false)
@Composable
private fun EstimateConfigurationEmailPreview() {
    HotPreviewApp(
        Modifier.fillMaxSize(),
        isDarkTheme = isSystemInDarkTheme(),
        isPreview = true
    ) {
        EstimateConfigurationEmail(
            Modifier.fillMaxSize(),
            FakeEstimateScreenModel()
        )
    }
}
